import { createContext } from "react"
import { AdPlace } from "Types/place"
import { Board, BoardModifyDialog } from "Types/board"
import { Material } from "Types/material"
export interface SelectDateRange {
    start: Date,
    end: Date,
}
export interface EditMaterial {
    modifyData: Material | null,
    open: boolean,
    update: boolean,
    isBom?: boolean,
    handleClose: () => void,
    handleConfirm: (editData: Material) => void,
}
export const CalendarContext = createContext<{
    currentDate: Date,
    handleChangeCurrentDate: (date: Date) => void,
    backToToday: () => void,
    places: AdPlace[],
    board: Board[],
    channelName: string,
    privilegeMap: {[key: string]: {[key: string]: boolean}},
    // 拖拽相关
    selectPlaceId: number,
    handleChangeSelectPlaceId: (id: number) => void,
    resetPlaceId: () => void,
    selectDateRange: SelectDateRange | null,
    handleSetSelectDateRange: (range: SelectDateRange | null) => void,
    // 预约弹窗相关
    boardModifyDialog: BoardModifyDialog | null,
    handleChangeBoardModifyDialog: (childMap: BoardModifyDialog | null) => void,
    isWeibo: boolean,
    isWeChat: boolean,
    isSpecies: boolean,
    isHealth: boolean,
    privilege: {[key: string]: boolean},
    movableBoard: Board | null,
    handleSetMovableBoard: (board: Board | null) => void,
    editMaterial: EditMaterial,
    handleSetEditMaterial: (material: EditMaterial) => void,
}>({
    currentDate: new Date(),
    handleChangeCurrentDate: () => {},
    backToToday: () => {},
    places: [],
    board: [],
    channelName: "",
    privilegeMap: {},
    selectPlaceId: 0,
    handleChangeSelectPlaceId: () => {},
    resetPlaceId: () => {},
    selectDateRange: null,
    handleSetSelectDateRange: () => {},
    boardModifyDialog: null,
    handleChangeBoardModifyDialog: () => {},
    isWeibo: false,
    isWeChat: false,
    isSpecies: false,
    isHealth: false,
    privilege: {},
    movableBoard: null,
    handleSetMovableBoard: () => {},
    editMaterial: {
        modifyData: null,
        open: false,
        update: false,
        isBom: false,
        handleClose: () => {},
        handleConfirm: () => {},
    },
    handleSetEditMaterial: () => {},
})

export const CalendarProvider = CalendarContext.Provider
